module.exports = __webpack_public_path__ + "cc7903d7600976e4d555e60f1da27d56.png";